import { motion } from "framer-motion";
import { Phone, Calendar, Star, ShieldCheck } from "lucide-react";
import { CLINIC, IMAGES } from "@/data";

export default function Hero() {
  return (
    <section id="home" data-testid="hero-section" className="relative min-h-[100svh] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img src={IMAGES.hero} alt="Proactive Dental clinic" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-pd-forest/90 via-pd-forest/70 to-pd-forest/30" />
        <div className="absolute inset-0 bg-gradient-to-t from-pd-forest/60 to-transparent" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 w-full pt-28 pb-16">
        <motion.div
          initial="hidden"
          animate="show"
          variants={{ hidden: {}, show: { transition: { staggerChildren: 0.12 } } }}
          className="max-w-2xl"
        >
          <motion.div
            variants={{ hidden: { opacity: 0, y: 20 }, show: { opacity: 1, y: 0 } }}
            className="inline-flex items-center gap-2 rounded-full bg-white/10 backdrop-blur-md border border-white/20 px-4 py-1.5 mb-6"
          >
            <span className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={14} className="fill-pd-accent text-pd-terra" />
              ))}
            </span>
            <span className="text-white/90 text-xs font-medium tracking-wide">Trusted by Burpengary families since 2010</span>
          </motion.div>

          <motion.h1
            variants={{ hidden: { opacity: 0, y: 24 }, show: { opacity: 1, y: 0 } }}
            className="font-display text-5xl sm:text-6xl lg:text-7xl font-light leading-[1.02] tracking-tight text-white"
          >
            Gentle, premium <br />
            <span className="italic text-pd-terra">dental care</span> for <br />
            your whole family.
          </motion.h1>

          <motion.p
            variants={{ hidden: { opacity: 0, y: 24 }, show: { opacity: 1, y: 0 } }}
            className="mt-6 text-lg text-white/80 leading-relaxed max-w-xl"
          >
            From nervous first-timers to complete smile makeovers — experience calm,
            affordable dentistry in the heart of Burpengary, Morayfield & Narangba.
          </motion.p>

          <motion.div
            variants={{ hidden: { opacity: 0, y: 24 }, show: { opacity: 1, y: 0 } }}
            className="mt-9 flex flex-col sm:flex-row gap-4"
          >
            <a
              href="#contact"
              data-testid="hero-book-btn"
              className="inline-flex items-center justify-center gap-2 bg-pd-terra hover:bg-pd-terradark text-white rounded-full px-8 py-4 font-medium transition-all duration-300 hover:shadow-xl hover:shadow-pd-terra/30 hover:-translate-y-0.5"
            >
              <Calendar size={18} /> Book an Appointment
            </a>
            <a
              href={`tel:${CLINIC.phoneRaw}`}
              data-testid="hero-call-btn"
              className="inline-flex items-center justify-center gap-2 border border-white/40 text-white hover:bg-white hover:text-pd-forest rounded-full px-8 py-4 font-medium transition-all duration-300"
            >
              <Phone size={18} /> {CLINIC.phoneDisplay}
            </a>
          </motion.div>

          <motion.div
            variants={{ hidden: { opacity: 0, y: 24 }, show: { opacity: 1, y: 0 } }}
            className="mt-10 flex items-center gap-2 text-white/70 text-sm"
          >
            <ShieldCheck size={18} className="text-pd-sage" />
            Free Kids Dental (CDBS) · All major health funds · HICAPS on-the-spot claims
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}

